import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

/**
 * A subtle mobile-only "Reserve" pill that fades in once the guest scrolls
 * past the hero. Hidden on desktop (the top nav already has a Reserve button)
 * and on the booking / payment pages themselves.
 */
export default function StickyReserve() {
  const { t } = useI18n();
  const loc = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show once we've scrolled roughly one screen height (past the hero)
      setVisible(window.scrollY > window.innerHeight * 0.85);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Never show on booking / payment / admin / guest / review routes
  const hiddenRoutes = ["/booking", "/payment", "/admin", "/guests", "/review"];
  if (hiddenRoutes.some(p => loc.pathname.startsWith(p))) return null;

  return (
    <Link
      to="/booking"
      data-testid="sticky-reserve"
      aria-label={t("nav.reserve")}
      className={[
        "md:hidden fixed z-40 bottom-6 right-5",
        "btn-brass px-6 py-3.5 rounded-full text-xs font-medium tracking-widest uppercase",
        "shadow-lg shadow-ionian/25",
        "transition-all duration-500",
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-4 pointer-events-none",
      ].join(" ")}
    >
      {t("nav.reserve")}
    </Link>
  );
}
